import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import { GetUserCashbackBonusInfoResponse } from './CashbackBonus.types';

export const getCashbackAsync = async (): Promise<
  ApiResponseType<GetUserCashbackBonusInfoResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetUserCashbackBonusInfoResponse>
  >(`/bonus/cashback/info`);
  return data;
};

export const claimCashbackAsync = async (): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/bonus/cashback/claim`
  );
  return data;
};
